import axios from "axios";
import qs from "qs";

export default function apiRequest({
  method = "get",
  url,
  endpoint = "",
  query = {},
  token,
  payload = {},
  responseType = "json",
  type = "application/json",
  timeout,
}) {
  
  const fullUrl = `${url}${endpoint}`;

  const axiosConfig = {
    method,
    url: fullUrl,
    params: query,
    data: payload,
    responseType,
    ...(timeout ? { timeout } : {}),
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
    headers: {
      "Content-Type": type,
    },
  };

  if (token) {
    axiosConfig.headers["Authorization"] = `Bearer ${token}`;
  }
  if (type !== 'formData') {
    axiosConfig.headers['Content-Type'] = type;
  }
  
  return new Promise((resolve, reject) => {
    axios(axiosConfig)
      .then((response) => resolve(response.data))
      .catch((error) => {
        console.error("API Request Error:", error);
        const errorBody = error.response?.data || { message: error.message || "API Error" };
        reject(errorBody);
      });
  });
}
